var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5Z",
    fill: "#F2EE97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9023 10.2151V12.9032L13.9104 13.9113M17.9729 15.8958C19.073 16.4899 19.6228 16.7876 19.6228 17.2715C19.6228 17.7554 19.073 18.0531 17.9729 18.6472L17.2243 19.0511C16.3795 19.5074 15.9575 19.7352 15.7545 19.5699C15.2572 19.1633 16.032 18.1156 16.2222 17.7446C16.4158 17.3683 16.4118 17.168 16.2222 16.7984C16.032 16.4274 15.2572 15.3797 15.7545 14.9731C15.9575 14.8078 16.3795 15.0356 17.2243 15.4919L17.9729 15.8958Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5916 19.5887C13.3649 19.6116 13.135 19.6232 12.9021 19.6237C9.19038 19.6237 6.18164 16.6149 6.18164 12.9032C6.18164 9.19154 9.19038 6.1828 12.9021 6.1828C16.6138 6.1828 19.6225 9.19154 19.6225 12.9032C19.6216 13.3647 19.5768 13.8127 19.4881 14.2473",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduled);
export default __webpack_public_path__ + "static/media/scheduled.e0048aaa463fa58468d8011210738cc3.svg";
export { ForwardRef as ReactComponent };